import { defineStore } from 'pinia';
import http from '@/core/http';

export const systemStore = defineStore('system', {
  actions: {
    // 添加商户号
    addMchId(payload) {
      return http.req_post('/admin/action/savemchid', { ajax: 1, ...payload });
    },
    // 商户号列表
    mchIdList(payload) {
      return http.req_get('/admin/action/getmchidlist', { ajax: 1, ...payload });
    },
    // 收款商户号关联服务商
    mchIdBindServicer(payload) {
      return http.req_get('/admin/action/savemchid4fws', { ajax: 1, ...payload });
    },
  }
});